// import Image from './image.vue'
import pagination from '@/components/pagination/index'
import image from '@/components/image/index'
import uploadImg from '@/components/uploadImg/index'
import uploadVideo from '@/components/uploadVideo'
import tooltip from '@/components/tooltip/index'
import addImage from '@/components/addImage/index'
import uploadVideoNew from '@/components/uploadVideoNew'
import MpmTable from '@/components/MpmTable/index.vue'
import MpmInput from '@/components/MpmInput.vue'
import MpmVideo from '@/components/mpm-video/index.vue'
export default {
  'mpm-pagination': pagination,
  'mpm-image': image,
  'mpm-uploadImg': uploadImg,
  'mpm-uploadVideo': uploadVideo,
  'mpm-uploadVideoNew': uploadVideoNew,
  'mpm-tooltip': tooltip,
  'mpm-addImage': addImage,
  'mpm-table': MpmTable,
  'mpm-input': MpmInput,
  'mpm-video': MpmVideo,
}
